module.exports = __webpack_public_path__ + "static/img/玫瑰.1c3b03b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/玫瑰.png?20181011
// module id = QP13
// module chunks = 1